import { RootState } from '@Store/index';
import {
  getRequestTypeDictSelector,
  getRequisitionRequestTypeDictSelector,
} from '@Store/selectors/dictionarySelector';
import { createSelector } from '@reduxjs/toolkit';
import { prepareRequestTypeOptions } from '@Utils/transformToOptions';
import { requestsCountSelector } from '@Store/selectors/headerSelector';

import { requestTypeOptionsAllowed } from './requestTypeOptionsAllowed';

const manageRequest = (state: RootState) => state.featureStores.manageRequest;

export const currentSelectedRequest = createSelector(
  manageRequest,
  ({ selectedRequest }) => selectedRequest
);

export const currentActionComponent = createSelector(
  manageRequest,
  ({ actionComponent }) => actionComponent
);

export const getRequisitionRequestTypeOptions = createSelector(
  [getRequisitionRequestTypeDictSelector, requestsCountSelector],
  (requestTypeDict, requestsCount) => {
    const requestTypeOptions = prepareRequestTypeOptions(
      requestTypeDict,
      requestsCount
    );
    return requestTypeOptions;
  }
);

export const getRequestTypeOptions = createSelector(
  [getRequestTypeDictSelector, requestsCountSelector],
  (requestTypeDict, requestsCount) => {
    const requestTypeDictFiltered = requestTypeDict.filter(
      (requestType) => requestTypeOptionsAllowed[requestType.codeNum]
    );

    const requestTypeOptions = prepareRequestTypeOptions(
      requestTypeDictFiltered,
      requestsCount
    );
    return requestTypeOptions;
  }
);
